"use client";

import { pathsConfig } from "~/config/paths";
import { TurboLink } from "~/modules/common/turbo-link";

interface SiteBrandProps {
  readonly ariaLabel: string;
  readonly href?: string;
}

export const SiteBrand = ({
  ariaLabel,
  href = pathsConfig.index,
}: SiteBrandProps) => {
  return (
    <TurboLink
      href={href}
      className="flex shrink-0 items-center gap-3"
      aria-label={ariaLabel}
    >
      <img
        src="/images/MSR_Logo_alpha.png"
        alt="Marine Survey Reports"
        className="h-10 w-auto object-contain sm:h-11"
      />
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <span className="text-foreground whitespace-nowrap text-base leading-none font-semibold sm:text-lg">
        Marine Survey Reports
      </span>
    </TurboLink>
  );
};
